import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { getTemplateFromMakeId } from '../templates/display/data/templates';
import DisplayFeedTemplate from '../templates/display/components/DisplayFeedTemplate';

const styles = {
  row: {
    display: 'inline-flex',
  },
  column: {
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
};

const PreviewFrames = (props) => {
  const { classes } = props;
  if (!props.feed || props.feed.length === 0) {
    return (
      <div className={props.className}>
        <Typography
          align="center"
          color="textSecondary"
          variant="display1"
          style={{ marginTop: 20 }}
        >
            Select Make, Model, Year to See Ads
        </Typography>
      </div>

    );
  }
  const { makeId } = props.feed[0];
  const templateName = getTemplateFromMakeId(makeId, props.templates);

  return (
    <div className={props.className}>
      <DisplayFeedTemplate templateName={templateName} feed={props.feed} width={728} height={90} />
      <div className={classes.row}>
        <DisplayFeedTemplate templateName={templateName} feed={props.feed} width={160} height={600} />
        <DisplayFeedTemplate templateName={templateName} feed={props.feed} width={300} height={600} />
        <div className={classes.column}>
          <DisplayFeedTemplate templateName={templateName} feed={props.feed} width={320} height={50} />
          <DisplayFeedTemplate templateName={templateName} feed={props.feed} width={300} height={250} />
        </div>
      </div>
    </div>
  );
};

PreviewFrames.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object,
  feedRow: PropTypes.object,
  feed: PropTypes.arrayOf(PropTypes.object),
  templates: PropTypes.object,
};

const mapStateToProps = (state) => ({
  templates: state.templates,
});

export default connect(mapStateToProps)(withStyles(styles)(PreviewFrames));




// WEBPACK FOOTER //
// ./src/preview/DisplayFeedPreview.jsx